<template>
  <div class="invite-modal">
    <div class="invite-modal__title">Invite User</div>
    <InviteUserPopupStep1 v-if="!userData"
      @search-result="applySearchResult"
      @cancel="cancel"
    />
    <InviteUserPopupStep2 v-else
      :userData="userData"
      :isExisting="isExistingUser"
      :availableRoles="roles"
      @back="returnToStep1"
      @cancel="cancel"
    />
  </div>
</template>

<script>
  // eslint-disable-next-line no-unused-vars
import UserManagement from './index'
import BaseModalMixins from '@/common/BaseModalMixins'
import InviteUserPopupStep1 from './InviteUserPopupStep1.vue'
import InviteUserPopupStep2 from './InviteUserPopupStep2.vue'
/**
 * Current popup shows when we clicked invite button in {@link UserManagement} page
 * For validation the form we use there "vee-validate" library
 */
export default {
  name: 'InviteUserPopup',
  mixins: [BaseModalMixins],
  props: ['roles'],
  components: {
    InviteUserPopupStep1,
    InviteUserPopupStep2
  },
  data () {
    return {
      userData: null,
      isExistingUser: false
    }
  },
  computed: {
  },
  methods: {
    //  Decline invite process
    close () {
      this.$emit('cancel')
    },
    applySearchResult(searchResult) {
      this.isFirstStep = false
      if (typeof searchResult === 'string') {
        this.userData = {
          email: searchResult,
          firstName: '',
          lastName: '',
          roleId: ''
        }
        this.isExistingUser = false
      } else {
        const { email, first_name, last_name, role_id, id } = searchResult
        this.userData = {
          email,
          firstName: first_name,
          lastName: last_name,
          roleId: role_id,
          userId: id
        }
        this.isExistingUser = true
      }
    },
    returnToStep1() {
      this.userData = null
    },
    cancel() {
      this.$emit('cancel')
    }
  }
}
</script>

<style scoped lang="scss">

  .invite-modal {
    padding: 40px;
    border-radius: 13px;
    box-sizing: border-box;
    box-shadow: 0 16px 32px 0 rgba(1, 22, 39, 0.5);
    background-color: white;

    &::v-deep .invite-modal {
      &__form-control {
        display: flex;
        flex-direction: column;
        gap: 5px;
        position: relative;
        padding-bottom: 20px;

        &_full-size {
          flex: 1 1 100%;
        }

        &_half-size {
          flex: 0 1 50%;
        }
      }

      &__label {
        font-weight: 600;
        height: 16px;
        line-height: 16px;
      }

      &__field {
        height: 40px;
        padding: 0 15px;
        border: 1px solid $rfx-light-steel;
        outline: none;
        border-radius: 4px;
        font-size: 14px;
        font-weight: 500;
        color: $rfx-dark-march;
        box-sizing: border-box;

        &_invalid {
          border-bottom-color: $rfx-red;
        }

        &:read-only {
          cursor: not-allowed;
          background-color: $rfx-almost-white;
        }
      }

      &__select {
        .select__selection,
        .select__placeholder {
          padding-left: 15px !important;
        }

        &_invalid {
          .select__header {
            border-bottom-color: $rfx-red !important;
          }
        }
      }

      &__error {
        position: absolute;
        left: 5px;
        bottom: 5px;
        font-size: 11px;
        color: $rfx-red;
      }

      &__row {
        display: flex;
        gap: 20px;
        align-items: flex-end;
      }

      &__subtitle {
        font-size: 20px;
        margin-bottom: 10px;
      }

      &__text {
        margin: 0 0 20px;
      }

      &__controls {
        display: flex;
        justify-content: flex-end;
        gap: 20px;
      }

      &__button {
        height: 40px;
        padding: 0 20px;
        border-radius: 4px;
        font-size: 10px;
        font-weight: 600;
        text-transform: uppercase;
        border: none;
        outline: none;
        cursor: pointer;
        color: $rfx-dark-march;
        background-color: #fff;

        &_submit {
            background-color: $rfx-medium-march;
            color: #fff;
        }

        &_single-cancel {
          border: 1px solid $rfx-silver;
        }

        &:disabled {
            opacity: .4;
            cursor: default !important;
        }
      }

      &__loader {
        position: absolute;
        top: -10px;
        left: -10px;
        right: -10px;
        bottom: -10px;
        border-radius: 4px;
        background: rgba(0, 0, 0, .1);
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }

    &__title {
      text-align: center;
      font-size: 34px;
      font-weight: bold;
      margin: 9px 0 35px;
      color: $rfx-dark-march;
    }
  }
</style>
